function hasDataTag(dataTag) {
  const tag = document.querySelector(dataTag);
  return tag || null;
}

function disabledAddToCartButton(container, data) {
  if (!container) return;

  const warning = document.querySelector("[data-info-supps='supps']");

  container.setAttribute("disabled", true);
  container.classList.add("hidden-button");

  if (data === "CA") {
    let canada = document.querySelector("[data-info-can-supps='supps']");
    canada.classList.remove("hidden-canada-button-locksmith");
  }

  warning.classList.remove("hidden-label-locksmith");
}

// Check if the data tag exists and the user is not in the US
(async function () {
  const hasSuppTag = hasDataTag("[data-supps='true']");
  const addToCartButton = document.querySelector("[data-add-to-cart]");
  const KEY = "locksmith";

  const countryCode = await fetch(
    window.Shopify.routes.root +
      "browsing_context_suggestions.json" +
      "?country[enabled]=true" +
      `&country[exclude]=${window.Shopify.country}`
  )
    .then((res) => res.json())
    .then((data) => {
      const countryCode = data.detected_values.country.handle;
      localStorage.setItem(
        KEY,
        JSON.stringify({
          country: countryCode,
          created_at: new Date().getTime(),
        })
      );
      return countryCode;
    })
    .catch((reason) => {
      console.log("Error:", reason);
      const localStorage = localStorage.getItem(KEY);
      const data = JSON.parse(localStorage);
      return data.country;
    });

  if (hasSuppTag && countryCode !== "US") {
    // Call the disabledAddToCartButton function with the
    disabledAddToCartButton(addToCartButton, countryCode);
  }
})();
